"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nativeApi_1 = require("./nativeApi");
var domWalks_1 = require("./domWalks");
/**
 * According to spec slot have only default content in their children properties
 */
/* istanbul ignore next - no domino implementation */
function patchSlot(slot) {
    if (slot.__patched) {
        return;
    }
    Object.defineProperty(slot, 'firstChild', {
        configurable: true,
        enumerable: true,
        get: function () {
            if (showNativeChild(this)) {
                return this.childNodes[0] || null;
            }
            else {
                return null;
            }
        },
        set: function (v) { }
    });
    Object.defineProperty(slot, 'lastChild', {
        configurable: true,
        enumerable: true,
        get: function () {
            if (showNativeChild(this)) {
                return this.childNodes[slot.childNodes.length - 1] || null;
            }
            else {
                return null;
            }
        },
        set: function (v) { }
    });
    Object.defineProperty(slot, 'assignedElements', {
        value: function () { return this.childNodes; }
    });
    slot.__patched = true;
}
exports.patchSlot = patchSlot;
/* istanbul ignore next - no domino implementation */
function showNativeChild(slot) {
    // expose actual first child when native api exposed
    // or when default content is being rendered into the slot
    return nativeApi_1.isNativeApiExposed() || slot.__exposeSlotAPI;
}
/**
 * Patch all slots inside the root element
 */
function patchSlots(root) {
    var slots = domWalks_1.findSlots(root);
    slots.forEach(patchSlot);
}
exports.patchSlots = patchSlots;
